module.exports = __webpack_public_path__ + "media/images/technology/paper2-icon-e11e454a26851e5f95a0eb747ffc6d17.png";